import { Injectable } from "@angular/core";
import { AppService } from "src/app/app.service";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class TemplatesService {
  private templatesTypesAndValues: any[];
  private appData: any;

  constructor(private httpClient: HttpClient, appService: AppService) {
    this.appData = appService.settings;
  }

  getTemplatesTypesAndValues(): any[] {
    return this.templatesTypesAndValues;
  }

  getTemplates(
    page: string,
    size: string,
    sort: string,
    filters: any,
    isWholesaleCorp: string
  ): Observable<any> {
    let params = new HttpParams();

    if (page) {
      params = params.append("page", page);
    }

    if (size) {
      params = params.append("size", size);
    }

    if (sort) {
      params = params.append("sort", sort);
    }

    Object.keys(filters).forEach((key) => {
      if (filters[key] && filters[key] !== "") {
        params = params.append(key, filters[key]);
      }
    });

    if(isWholesaleCorp != ""){
      params = params.append("corp", isWholesaleCorp);
    }

    return this.httpClient.get(
      `${this.appData.webApi}/inventory/templates/getTemplates`,
      { params }
    );
  }

  getTemplatesTypes(): Observable<any> {
    return this.httpClient.get(
      `${this.appData.webApi}/inventory/templates/getTemplatesTypes`
    );
  }

  getTemplatesValuesFromType(url: string): Observable<any> {
    return this.httpClient.get(
      `${this.appData.webApi}/inventory/templates/getTemplatesValuesFromType/${url}`
    );
  }

  getTemplatesValues(): Observable<any> {
    return this.httpClient.get(
      `${this.appData.webApi}/inventory/templates/getTemplatesValues`
    );
  }

  createTemplate(template: any): Observable<any> {
    return this.httpClient.post(
      `${this.appData.webApi}/inventory/templates/createTemplate`,
      template
    );
  }

  editTemplate(body: any): Observable<any> {
    return this.httpClient.patch(
      `${this.appData.webApi}/inventory/templates/editTemplate`,
      body
    );
  }

  changeTemplateState(id: number): Observable<any> {
    const params = new HttpParams().append("id", id.toString());
    return this.httpClient.patch(
      `${this.appData.webApi}/inventory/templates/changeTemplateState`,
      undefined,
      { params }
    );
  }

  deleteTemplate(id: number): Observable<any> {
    const params = new HttpParams().append("id", id.toString());
    return this.httpClient.delete(
      `${this.appData.webApi}/inventory/templates/deleteTemplate`,
      { params }
    );
  }
}
